//  * @package         src/components/Dashboard
//  * @author          Riddhi D Parekh
//  * @date            22nd October 2018
//  * @type            Left Panel Component File
//  * @description -   This file renders the html and functionality for complete left(first) component.
<template>
    <div class="col-md-3 p-0 col-xs-12 survey_colume_1">
      <div v-bar="{scrollThrottle: 30, draggerThrottle: 30, preventParentScroll: true}" ref="vbarElement">
        <div class="colume_1_option sticky_bar">
            <div class="colume_1_option_tab">
          <ul class="nav">
              <li>
            <a
                :class="{active:selected == 1}"
                v-on:click="questUpdated === 1 ? $awn.confirm('Do you want to save current question first?',callSaveMethod,callCancelMethod) :selected = 1"
                >{{ $t("attributes.setting") }}s</a>
              </li>
              <li>
            <a
                :class="{active:selected== 2}"
                v-on:click="questUpdated === 1 ? $awn.confirm('Do you want to save current question first?',callSaveMethod,callCancelMethod) :selected = 2"
                >{{ $t("attributes.design") }}</a>
              </li>
              <li v-if="all.in_status != vueCommonConfig.SURVEY_PUBLISHED" v-cloak>
            <a
                :class="{active:selected == 3}"
                v-on:click="questUpdated === 1 ? $awn.confirm('Do you want to save current question first?',callSaveMethod,callCancelMethod) :selected = 3"
                >{{ $t("attributes.question") }}s</a>
              </li>
          </ul>
            </div>
            <!-- <component :initialData="userData"
                  v-bind:is="currentComponent"
            ></component>-->
            <component v-bind:is="currentComponent"></component>
        </div>
      </div>
    </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import { EventBus } from "../../main";
import designleft from "./designleft";
import settingleft from "./settingleft";
import questionsleft from "./questionsleft";
var { constantCommonConfig } = require("../../../config/config.js");

export default {
  name: "left",
  components: {
    designleft,
    settingleft,
    questionsleft
  },
  data() {
    return {
      selected: 3,
      tabs: ["settingleft", "designleft", "questionsleft"],
      vueCommonConfig: constantCommonConfig,
      currentComponent: "questionsleft"
    };
  },
  computed: {
    // for icons above start screen
    ...mapGetters("LeftSidebarCreate", ["all"]),
    ...mapGetters("editquestionEdit", {
      questUpdated: "questionUpdated"
    })
  },
  watch: {
    selected: function(val) {
      this.refreshVueBar();
      this.currentComponent = this.tabs[val - 1];
      EventBus.$emit("LeftTabSelected", this.currentComponent);
    },
    all: {
      handler() {
        // Switch tab on page load
        this.updateSelectedTabs();
      }
    }
  },
  created() {
    // After switching tab from Skip Logic into Questions tab default tabs not working so we need to call in created instance
    this.updateSelectedTabs();
  },
  methods: {
    callSaveMethod: function() {
      EventBus.$emit("saveQuestionFromCenterQuestions");
    },
    callCancelMethod: function() {
      EventBus.$emit("cancelQuestionFromCenterQuestions");
    },
    updateSelectedTabs() {
      // Change settings tab if survey is published
      if(this.all.in_status == this.vueCommonConfig.SURVEY_PUBLISHED)
        this.selected = 1;
    },
    refreshVueBar() {
      this.$vuebar.refreshScrollbar(this.$refs.vbarElement, {
        scrollThrottle: 30,
        draggerThrottle: 30,
        preventParentScroll: true,
      });
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/left.vue